<template>
  <div class="pageview">
    <PhotoViewDb :pagename="pagename" :galleryFilter="galleryFilter" />
  </div>
</template>

<script>
import PhotoViewDb from "@/components/PhotoViewDb";

export default {
  components: { PhotoViewDb },
  data() {
    return {
      pagename: "TBC Default",
      galleryFilter: "default"
    };
  },
  created() {
    this.pagename = this.$route.params.pagename;

    this.galleryFilter = this.$route.params.filter;
  }
  // watch: {
  //   $route: {
  //     handler: "updateParams",
  //     immediate: true
  //   },
  //   methods: {
  //     updateParams() {
  //       this.pagename = this.$route.params.pagename;

  //       this.galleryFilter = this.$route.params.filter;

  //       console.log("pagename :" + this.$route.params.pagename);
  //     }
  //   }
  // }
};
</script>